import * as React from 'react';
import { observer } from 'mobx-react';

import { UitkRemovablePill } from 'uitk-react-pill';
import { UitkTertiaryButton } from 'uitk-react-button';
import { liveAnnounce } from 'uitk-react-utils';

import { AppliedFiltersSummaryType, AppliedFiltersType } from 'types/search/sort-filter';
import { analyticsConfigMapper, trackAnalytics } from 'utility';
import { useHydrationEnable, useStores } from 'utility/hooks';

interface FilterPillsProps {
  appliedFiltersSummary: AppliedFiltersSummaryType;
}

export const FilterPills = observer((props: FilterPillsProps) => {
  const hydrated = useHydrationEnable();
  const {
    routeStore,
    context,
    advertisingStore,
    searchCriteriaStore,
    analytics,
    listingsStore: { loading },
    sortFilterStore
  } = useStores();

  const {
    appliedFiltersSummary: { appliedFilters }
  } = props;

  const renderPill = (filter: AppliedFiltersType, key: number) => {
    const removePill = () => {
      advertisingStore.showCLAds(false);
      const { sortPresentation } = sortFilterStore;
      const sortOption =
        sortPresentation && sortPresentation.selectedOption && sortPresentation.selectedOption.sortType;
      searchCriteriaStore.clearPagination();
      searchCriteriaStore.syncWithAppliedSortAndFilterNextSearchCriteria(filter, sortOption);
      searchCriteriaStore.triggerSearch(routeStore, context, undefined, false, false);
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      appliedFilters.remove(filter);
      advertisingStore.displayAdRefresh();
    };

    return (
      <UitkRemovablePill
        id={`Removable-${key}`}
        onClick={removePill}
        key={key}
        disabled={!hydrated || loading}
        altText={filter.accessibilityMessage}
        analytics={analyticsConfigMapper(filter.analytics, analytics)}
        className="all-b-margin-one"
      >
        {filter.label}
      </UitkRemovablePill>
    );
  };

  const { clearAllSelectionLabel } = sortFilterStore;

  const clearFilters = (): void => {
    sortFilterStore.clearFilters();
    sortFilterStore.applySortAndFilter(searchCriteriaStore, routeStore, advertisingStore, context, analytics);
    trackAnalytics(clearAllSelectionLabel.analytics, analytics);
    liveAnnounce(clearAllSelectionLabel.accessibility.onCompletion);
  };

  return (
    appliedFilters.length > 0 && (
      <div className="uitk-cell all-b-padding-six" data-test-id="active-filters-container">
        {appliedFilters.map((pill, key) => renderPill(pill, key))}
        <UitkTertiaryButton
          text={clearAllSelectionLabel.label}
          data-test-id="filter-clear-all"
          onClick={clearFilters}
          disabled={false}
          aria-label={clearAllSelectionLabel.accessibility && clearAllSelectionLabel.accessibility.usage}
        />
      </div>
    )
  );
});
